module.exports = __webpack_public_path__ + "img/fXdRzWDW.18f90631.svg";